import type { FaireProductEntity } from "../../entity_types/product";

export const p_gztsyhv8xt: FaireProductEntity = {
  token: "p_gztsyhv8xt",
  type: "product",
  name: "Vesty - Boho Colorblock Knit Vest- Comfortable & Fit",
  brandToken: "b_qrthtbpuwu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e586288801975268c2a8c6fe05ffc1ec6be58ec8287145c3f930351a720655a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b97ccc9159e3e2709dca0d1b322d3e6ad3b48327411cdd2296271e0786c90db0.jpeg",
    "https://cdn.faire.com/fastly/cede42e54fb2cb3e2aa96222b74e664cc05e16758679c615f27ac24591163cba.jpeg",
    "https://cdn.faire.com/fastly/0826fd5687778b25e74359f14260f0812100eb623990cd309141495a94a7a461.jpeg",
    "https://cdn.faire.com/fastly/105d91db0d751b4f798bd03e1faf154ca3ccbbcdb168fe9b2ed696480b5bce76.jpeg",
    "https://cdn.faire.com/fastly/9ec373e3a7a75218206b19b0bfeb2827d98246c6bb5bc13d1359b38082cecb9f.jpeg",
    "https://cdn.faire.com/fastly/236502e3555135961e7be5519229c93193720c444b8ae8cc3e5e554581d3e5a2.jpeg",
    "https://cdn.faire.com/fastly/cae535d6467145feb55919f8c7ec4407ed3f22bde403d7e07b6634f038a42294.jpeg",
    "https://cdn.faire.com/fastly/5a04108ac0447666d638730f6dd0175dbdbdf871504d7c5e4d33e4edc4f63343.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "Embrace the spirit of summer with this bohemian-style cami! The playful colorblock stripes and airy crochet knit create the perfect blend of boho charm and dopamine fashion. Whether layered under a sheer cover-up or worn solo, its stretchy fabric keep you stylish all season long.\n\n * Crochet knit texture \n * Bold contrasting color stripes \n * Soft stretch for comfortable fit \n * Versatile for layering or standalone wear \n * Available in red/orange/brown \nPerfect for: music festivals, beach vacations, boho-chic styling\n People also consider: crochet tops, hippie fashion, summer festival wear",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:46.533Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
